<template>
  <div id="create-message-wise-page">
    <div class="page-header ">
      <div>
        <cloud-tags-wise />
        <create-message-wise
          @updateFormData="updateFormData"
          :placeholderUuid="placeholderUuid"
        />
        <message-flow-wise
          :message="formData.message"
          @updateMessage="updateMessage"
          @resetFormData="resetFormData"
        />
      </div>
      <router-link :to="editMessagePath" replace>
        <info-modal
          v-if="showConfirmModal"
          :isVisibleConfirm="showConfirmModal"
          @close="showConfirmModal = false"
          :message="'Mensagem salva com sucesso!'"
        />
      </router-link>
      <Loading
        v-if="showLoadingModalWise"
        :isLoading="isLoadingModalWise"
        :status="status"
        @close="showLoadingModalWise = false"
        :message="'KAKAK'"
      />
    </div>
  </div>
</template>

<script>
import cloudTagsWise from './components/cloudTagsWise.vue';
import createMessageWise from './components/createMessageWise.vue';
import messageFlowWise from './components/messageFlowWise.vue';
import { mapActions, mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import { createMessageInWise } from '../../../../../../api/wise';
import { frontendURL } from '../../../../../../helper/URLHelper';
import infoModal from '../../../components/InfoModal.vue';
import Loading from '../../../components/Loading.vue';
export default {
  components: {
    cloudTagsWise,
    createMessageWise,
    messageFlowWise,
    infoModal,
    Loading,
  },

  data() {
    return {
      placeholderUuid: uuidv4(),
      formData: {},
      showConfirmModal: false,
      showLoadingModalWise: false,
      isLoadingModalWise: false,
    };
  },

  computed: {
    ...mapGetters({
      userData: 'getUserData',
      accountId: 'getCurrentAccountId',
    }),
    ...mapActions({
      loadMessageWise: 'loadMessageWise',
    }),
    editMessagePath() {
      return frontendURL(`accounts/${this.accountId}/wise/editmessage/`);
    },
  },

  methods: {
    createFormData() {
      const date = new Date();
      return {
        device_id: '',
        user_id: '',
        date: date.toLocaleDateString('pt-BR'),
        title: '',
        channel: this.placeholderUuid,
        category: '',
        status: '',
        situation: '',
        message: [],
        notifications: null,
        notification_1: null,
        notification_2: null,
        notification_3: null,
        notification_4: null,
        weekend_shipping_lock: false,
        shipping_schedule: '',
      };
    },

    prepareFormData() {
      const newFormData = new FormData();
      newFormData.append('device_id', this.userData.device_id);
      newFormData.append('user_id', this.userData._id);
      newFormData.append('date', this.formData.date);
      newFormData.append('title', this.formData.title);
      newFormData.append('channel', this.formData.channel);
      newFormData.append('category', this.formData.category);
      newFormData.append('status', this.formData.status);
      newFormData.append('situation', this.formData.situation);
      newFormData.append('notification_1', this.formData.notification_1);
      newFormData.append('notification_2', this.formData.notification_2);
      newFormData.append('notification_3', this.formData.notification_3);
      newFormData.append('notification_4', this.formData.notification_4);
      newFormData.append('shipping_schedule', this.formData.shipping_schedule);
      newFormData.append(
        'weekend_shipping_lock',
        this.formData.weekend_shipping_lock
      );

      newFormData.append('message', JSON.stringify(this.formData.message));
      newFormData.append(
        'notifications',
        JSON.stringify(this.formData.notifications)
      );

      this.formData.message.forEach((msg, index) => {
        if (msg.file) {
          newFormData.append(`file${index + 1}`, msg.file);
        }
      });

      return newFormData;
    },

    updateFormData(data) {
      Object.assign(this.formData, data);
    },

    async updateMessage(newMessage) {
      this.formData.message = newMessage;
      this.showLoadingModalWise = true;
      this.isLoadingModalWise = true;
      await this.sendDataMessageWise();
      await this.loadMessageWise;
      this.isLoadingModalWise = false;
      this.showLoadingModalWise = false;

      this.showConfirmModal = true;
    },

    resetFormData() {
      this.formData = this.createFormData();
    },

    async sendDataMessageWise() {
      const dataToSent = this.prepareFormData();
      await createMessageInWise({
        payload: dataToSent,
      });
    },
  },

  created() {
    this.formData = this.createFormData();
  },
};
</script>

<style scoped>
#create-message-wise-page {
  background-color: #f2f7fb;
  font-size: 0.9375rem;
  overflow-x: hidden;
  color: #333;
  font-family: open sans, sans-serif;
  background-image: linear-gradient(rgba(255 255 255 / 0%) 240px, #f2f7fb 0%);
}

*:focus {
  outline: none;
}

a {
  font-size: 13px;
  color: #37474f;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-outf;
}
.card {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card .card-header.borderless {
  border-bottom: 0 solid transparent;
}

.card .card-header.borderless + .card-block,
.card .card-header.borderless + .card-block-big,
.card .card-header.borderless + .card-block-small {
  padding-top: 0;
}
.page-header {
  margin: 80px;
}
h4 {
  padding: 0;
  margin: 0;
}
.page-header-title {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 400;
  margin-bottom: 30px;
  background: #019ead;
  color: #fff;
}
.page-header-title span {
  font-size: 13px;
}
</style>
